import React from 'react';
import { Layout } from './features/layout';
import AppRoutes from './features/shared/routes/AppRoutes';
import ApolloProviderInternal from './apollo/ApolloProviderInternal.js';
import Loader from './features/loader/components/Loader.js';
import LandingPage from './features/layout/LandingPage';
import { Route, Routes } from 'react-router-dom';
import LoggedOutWarningPage from './features/unauthorized/LoggedOutWarningPage';
import SignarRProvider from './signalR/SignarRProvider';
import PendoProvider from './pendo/PendoProvider';
import DevelopmentLoginPage from './features/developmentLogin/developmentLoginPage';
import SystemWideModals from './features/shared/components/SystemWideModals';
import AuthenticatedRoute from '@shared/routes/AuthenticatedRoute';
import UnauthorizedPage from './features/unauthorized/UnauthorizedPage';
import { ToastContainer } from 'react-toastify';
import { SignalRSubscriptions } from './signalR/SignalRSubscriptions';

const localRoutesEnabled = () => !!process.env.LOCAL_DEVELOPMENT_LOGIN;

const App = () => (
  <Loader>
    <ApolloProviderInternal>
      <Routes>
        <Route path='/login' element={<LandingPage />} />
        <Route path='/session-ended' element={<LoggedOutWarningPage />} />
        {localRoutesEnabled() && (
          <Route path='/developmentLogin' element={<DevelopmentLoginPage />} />
        )}
        <Route path='/unauthorized' element={<UnauthorizedPage />} />
        <Route element={<AuthenticatedRoute />}>
          <Route
            path='*'
            element={
              <SignarRProvider>
                <PendoProvider>
                  <Layout>
                    <AppRoutes />
                    <SystemWideModals />
                    <SignalRSubscriptions />
                  </Layout>
                </PendoProvider>
              </SignarRProvider>
            }
          />
        </Route>
      </Routes>
      <ToastContainer newestOnTop pauseOnFocusLoss={false} />
    </ApolloProviderInternal>
  </Loader>
);

export default App;
